import { getComponentFromName } from '@folklore/utils';
import isString from 'lodash-es/isString';
import { ElementType } from 'react';

import useLocations from '../../hooks/useLocations';

import LocationHorizontalCard from '../cards/LocationHorizontalCard';
import PresentationList, { PresentationListProps } from './PresentationList';

const CardComponents = {
    Horizontal: LocationHorizontalCard,
};

const hooks = {
    default: useLocations,
};

interface LocationsListProps extends Omit<
    PresentationListProps<Location>,
    'cardComponent' | 'hook'
> {
    hook?: string | null;
    cardComponent?: ElementType | null;
    cardType?: string | null;
}

function LocationsList({
    hook = 'default',
    cardType,
    cardComponent,
    ...props
}: LocationsListProps) {
    return (
        <PresentationList<Location>
            hook={isString(hook) ? hooks[hook] || hooks.default : hook}
            {...props}
            cardComponent={
                cardComponent ||
                getComponentFromName(CardComponents, cardType, CardComponents.Horizontal)
            }
        />
    );
}

export default LocationsList;
